"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MeetingWorkspaceParticipantsSchema () {
        return MeetingWorkspaceParticipantsSchema;
    },
    get MeetingWorkspaceRolesSchema () {
        return MeetingWorkspaceRolesSchema;
    },
    get MeetingWorkspaceStatusSchema () {
        return MeetingWorkspaceStatusSchema;
    },
    get MeetingWorkspaceStatusSchemaWithDefault () {
        return MeetingWorkspaceStatusSchemaWithDefault;
    },
    get MeetingWorkspacesSchema () {
        return MeetingWorkspacesSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _meetinguseractionrecord = require("./meeting-user-action-record");
const MeetingWorkspaceRolesSchema = _zod.z.literal("editor");
const MeetingWorkspaceStatusSchema = _zod.z.enum([
    "active",
    "archived"
]);
const MeetingWorkspaceStatusSchemaWithDefault = MeetingWorkspaceStatusSchema.default("active");
const MeetingWorkspaceParticipantsSchema = _zod.z.object({
    role: MeetingWorkspaceRolesSchema,
    /** Foreign key - user document */ user_id: _zod.z.instanceof(_bson.ObjectId)
});
const MeetingWorkspacesSchema = _base.BaseDocument.extend({
    name: _zod.z.string(),
    status: MeetingWorkspaceStatusSchema,
    /**
	 * Workspaces participants are users who are part of the workspace.
	 * Depending on their role, user added to a workspace can view and
	 * participate in meetings.
	 */ participants: _zod.z.array(MeetingWorkspaceParticipantsSchema),
    created: _meetinguseractionrecord.UserActionRecord,
    updated: _meetinguseractionrecord.UserActionRecord
});
